const initialState = {
  items: [],
  plugins: [],
  collectionSnapshots: [],
  permissionFlags: null,
  selectedItem: null,
  totalItemPages: null,
  projectDetail: null,
  projectCollections: [],
  appWriteData: '',
  externalDatabase: '',
  appWriteDataCollection: '',
  dbCollectionUuid: '',
  tableSettings: {},
  metaDataTableMappings: [],
  selectedCollection: null,
  currentCollectionListPage: 0,
  totalCollectionPages: 0,
  selectedItemWithDetails: null,
  responseData: null,
  isOpenItemDetail: false,
  isOpenCollectionUpdateModel: false,
  isOpenCollectionCreateWithCsv: false,
  isOpenCollectionCreateWithRestApi: false,
  loadProjectCollectionsPending: false,
  loadProjectCollectionsError: null,
  loadProjectCollectionDetailPending: false,
  showConstructorCreateLoader: false,
  loadProjectCollectionDetailError: null,
  updateCollectionsPending: false,
  updateCollectionsError: null,
  createCollectionPending: false,
  createCollectionError: null,
  deleteCollectionPending: false,
  deleteCollectionError: null,
  editFieldPending: false,
  editFieldError: null,
  deleteFieldPending: false,
  deleteFieldError: null,
  createNewFieldPending: false,
  createNewFieldError: null,
  deleteConstructorPending: false,
  deleteConstructorError: null,
  createCollectionConstructorPending: false,
  createCollectionConstructorError: null,
  addUtilityFunctionToCollectionPending: false,
  addUtilityFunctionToCollectionError: null,
  deleteUitilityFunctionPending: false,
  deleteUitilityFunctionError: null,
  updateConstantOfCollectionPending: false,
  updateConstantOfCollectionError: null,
  deleteCollectionConstantPending: false,
  deleteCollectionConstantError: null,
  createCollectionConstantPending: false,
  createCollectionConstantError: null,
  addQueryToCollectionPending: false,
  addQueryToCollectionError: null,
  updateQueryOfCollectionPending: false,
  updateQueryOfCollectionError: null,
  deleteCollectionQueryPending: false,
  deleteCollectionQueryError: null,
  updateConstraintOfCollectionPending: false,
  updateConstraintOfCollectionError: null,
  deleteCollectionConstraintPending: false,
  deleteCollectionConstraintError: null,
  createCollectionConstraintPending: false,
  createCollectionConstraintError: null,
  addRuleToCollectionPending: false,
  addRuleToCollectionError: null,
  deleteCollectionValidationPending: false,
  deleteCollectionValidationError: null,
  loadCollectionItemsPending: false,
  loadCollectionItemsError: null,
  saveCollectionItemPending: false,
  saveCollectionItemError: null,
  updateCollectionItemPending: false,
  updateCollectionItemError: null,
  deleteItemPending: false,
  deleteItemError: null,
  loadItemDetailsPending: false,
  loadItemDetailsError: null,
  loadCollectionItemPending: false,
  loadCollectionItemError: null,
  deleteAllItemsPending: false,
  deleteAllItemsError: null,
  addWorkflowToCollectionPending: false,
  addWorkflowToCollectionError: null,
  deleteCollectionWorkflowPending: false,
  deleteCollectionWorkflowError: null,
  loadFilterDataPending: false,
  loadFilterDataError: null,
  filter_items: null,
  loadProjectSettingsPending: false,
  loadProjectSettingsError: null,
  loadProjectPluginsPending: false,
  loadProjectPluginsError: null,
  loadProjectDetailCollectionsPending: false,
  loadProjectDetailCollectionsError: null,
  createCollectionWithCsvPending: false,
  createCollectionWithCsvError: null,
  responceForRestApiPending: false,
  responceForRestApiError: null,
  saveDataInExternaldatabasePending: false,
  saveDataInExternaldatabaseError: null,
  loadExternalDatabasePending: false,
  loadExternalDatabaseError: null,
  updateExternalDatabasePending: false,
  updateExternalDatabaseError: null,
  cloneCollectionPending: false,
  cloneCollectionError: null,
  createCollectionWithJsonPending: false,
  createCollectionWithJsonError: null,
  importItemsFromJsonPending: false,
  importItemsFromJsonError: null,
  importItemsFromRestApiPending: false,
  importItemsFromRestApiError: null,
  deleteCollectionValidationRulesPending: false,
  deleteCollectionValidationRulesError: null,
  addSingleValidationRulePending: false,
  addSingleValidationRuleError: null,
  updateLookupPending: false,
  updateLookupError: null,
  enableLookupSettingPending: false,
  enableLookupSettingError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  updateFilterDetailsPending: false,
  updateFilterDetailsError: null,
  createCollectionSnapshotPending: false,
  createCollectionSnapshotError: null,
  loadCollectionSnapshotsPending: false,
  loadCollectionSnapshotsError: null,
  createPermissionLevelSecurityInCollectionPending: false,
  createPermissionLevelSecurityInCollectionError: null,
  createRowLevelSecurityFilterInCollectionPending: false,
  createRowLevelSecurityFilterInCollectionError: null,
  deleteRowLevelSecurityFilterPending: false,
  deleteRowLevelSecurityFilterError: null,
  updateTableSettingsPending: false,
  updateTableSettingsError: null,
  getTableSettingsPending: false,
  getTableSettingsError: null,
  createTypesenseMappingInCollectionPending: false,
  createTypesenseMappingInCollectionError: null,
  generateCrudPagesPending: false,
  generateCrudPagesError: null,
  createCollectionWithPromptPending: false,
  createCollectionWithPromptError: null,
  extractFieldsFromPromptPending: false,
  extractFieldsFromPromptError: null,
  promptItems: [],
  extractCollectionDataPending: false,
  extractCollectionDataError: null,
  generateCollectionDataPending: false,
  generateCollectionDataError: null,
  createMetaDataMappingInCollectionPending: false,
  createMetaDataMappingInCollectionError: null,
  deleteCollectionMetaDataTableMappingPending: false,
  deleteCollectionMetaDataTableMappingError: null,
  updateCollectionMetaDataTableMappingPending: false,
  updateCollectionMetaDataTableMappingError: null,
};

export default initialState;
